import { resolveComponent as _resolveComponent, createVNode as _createVNode, createElementVNode as _createElementVNode, toDisplayString as _toDisplayString, vModelText as _vModelText, withDirectives as _withDirectives, renderList as _renderList, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock, vModelRadio as _vModelRadio, createBlock as _createBlock } from "vue"

const _hoisted_1 = {
  class: "card",
  style: {"height":"86vh"}
}
const _hoisted_2 = { class: "w-100" }
const _hoisted_3 = {
  class: "text-center p-6",
  style: {"position":"absolute","top":"10px","left":"13px"}
}
const _hoisted_4 = { class: "svg-icon svg-icon-4x svg-icon-primary" }
const _hoisted_5 = { class: "pb-lg-3 pt-7" }
const _hoisted_6 = { class: "fw-bolder d-flex align-items-center text-dark text-center justify-content-center" }
const _hoisted_7 = { class: "form-group row justify-content-center mb-2" }
const _hoisted_8 = { class: "col-2 text-gray-400 fw-bold fs-6 text-end justify-content-end align-content-center" }
const _hoisted_9 = { class: "col-3 text-start" }
const _hoisted_10 = { class: "pt-3 w-100" }
const _hoisted_11 = { class: "fv-row" }
const _hoisted_12 = { class: "row justify-content-center" }
const _hoisted_13 = { class: "col-4" }
const _hoisted_14 = {
  for: "nameInput",
  class: "d-flex align-items-center text-dark text-center justify-content-center font-size-h4 form-label"
}
const _hoisted_15 = /*#__PURE__*/_createElementVNode("div", {
  id: "nameHelp",
  class: "form-text"
}, "Introduce sólo el nombre", -1)
const _hoisted_16 = { class: "col-2" }
const _hoisted_17 = {
  for: "ageInput",
  class: "d-flex align-items-center text-dark text-center justify-content-center font-size-h4 form-label"
}
const _hoisted_18 = { class: "col-5" }
const _hoisted_19 = { class: "row justify-content-center mt-1" }
const _hoisted_20 = { class: "fw-bolder d-flex align-items-center text-dark text-center justify-content-center mb-1" }
const _hoisted_21 = ["id", "value", "onUpdate:modelValue"]
const _hoisted_22 = ["for"]
const _hoisted_23 = { class: "d-block fw-bold text-start" }
const _hoisted_24 = { class: "text-dark fw-bolder d-block fs-4" }
const _hoisted_25 = /*#__PURE__*/_createElementVNode("div", { class: "pt-3 w-100" }, [
  /*#__PURE__*/_createElementVNode("div", { class: "fv-row" })
], -1)
const _hoisted_26 = { class: "text-start" }
const _hoisted_27 = { class: "fw-bolder d-flex align-items-center text-dark text-center justify-content-center" }
const _hoisted_28 = { class: "card w-100" }
const _hoisted_29 = { class: "col-12 text-center" }
const _hoisted_30 = ["disabled"]
const _hoisted_31 = { class: "indicator-label" }

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_inline_svg = _resolveComponent("inline-svg")!
  const _component_Datepicker = _resolveComponent("Datepicker")!
  const _component_ErrorMessage = _resolveComponent("ErrorMessage")!
  const _component_MapComponentOL = _resolveComponent("MapComponentOL")!

  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    _createElementVNode("div", _hoisted_2, [
      _createElementVNode("div", _hoisted_3, [
        _createElementVNode("span", _hoisted_4, [
          _createVNode(_component_inline_svg, { src: "/media/icons/landscape.svg" })
        ])
      ]),
      _createElementVNode("div", _hoisted_5, [
        _createElementVNode("h5", _hoisted_6, _toDisplayString(_ctx.router.currentRoute.value.name === "add-land-incident"
              ? _ctx.$t("regNewIncidentLand")
              : _ctx.$t("editIncident")), 1)
      ]),
      _createElementVNode("div", _hoisted_7, [
        _createElementVNode("div", _hoisted_8, _toDisplayString(_ctx.$t("whenHappend")), 1),
        _createElementVNode("div", _hoisted_9, [
          _createVNode(_component_Datepicker, {
            modelValue: _ctx.myprops.incidentData.value.landIncident.OccurrenceDateTime,
            "onUpdate:modelValue": _cache[0] || (_cache[0] = ($event: any) => ((_ctx.myprops.incidentData.value.landIncident.OccurrenceDateTime) = $event)),
            locale: "es",
            format: _ctx.format,
            autoApply: "",
            "time-picker-inline": "",
            closeOnAutoApply: false,
            minDate: _ctx.minDate,
            maxDate: 
              _ctx.maxDate == null
                ? new Date()
                : new Date(_ctx.maxDate) > new Date()
                ? new Date()
                : new Date(_ctx.maxDate)
            ,
            noToday: "",
            clearable: false,
            hideInputIcon: "",
            inputClassName: "dp-custom-input"
          }, null, 8, ["modelValue", "format", "minDate", "maxDate"])
        ])
      ])
    ]),
    _createElementVNode("div", _hoisted_10, [
      _createElementVNode("div", _hoisted_11, [
        _createElementVNode("div", _hoisted_12, [
          _createElementVNode("div", _hoisted_13, [
            _createElementVNode("label", _hoisted_14, _toDisplayString(_ctx.$t("generalData.nameInjured")), 1),
            _withDirectives(_createElementVNode("input", {
              type: "text",
              class: "form-control text-center",
              "aria-describedby": "nameHelp",
              "onUpdate:modelValue": _cache[1] || (_cache[1] = ($event: any) => ((_ctx.myprops.incidentData.value.landIncident.VictimName) = $event))
            }, null, 512), [
              [_vModelText, _ctx.myprops.incidentData.value.landIncident.VictimName]
            ]),
            _hoisted_15
          ]),
          _createElementVNode("div", _hoisted_16, [
            _createElementVNode("label", _hoisted_17, _toDisplayString(_ctx.$t("generalData.age")), 1),
            _withDirectives(_createElementVNode("input", {
              type: "number",
              min: "1",
              max: "110",
              class: "form-control text-center",
              "aria-describedby": "VictimAge input",
              "onUpdate:modelValue": _cache[2] || (_cache[2] = ($event: any) => ((_ctx.myprops.incidentData.value.landIncident.VictimAge) = $event))
            }, null, 512), [
              [_vModelText, _ctx.myprops.incidentData.value.landIncident.VictimAge]
            ])
          ]),
          _createElementVNode("div", _hoisted_18, [
            _createElementVNode("div", _hoisted_19, [
              _createElementVNode("label", _hoisted_20, _toDisplayString(_ctx.$t("generalData.gender")), 1),
              (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.genders, (VictimGender) => {
                return (_openBlock(), _createElementBlock("div", {
                  key: VictimGender.id,
                  class: "col-4"
                }, [
                  _withDirectives(_createElementVNode("input", {
                    type: "radio",
                    class: "btn-check",
                    id: VictimGender.id,
                    value: VictimGender.id,
                    "onUpdate:modelValue": ($event: any) => ((_ctx.myprops.incidentData.value.landIncident.VictimGender) = $event)
                  }, null, 8, _hoisted_21), [
                    [_vModelRadio, _ctx.myprops.incidentData.value.landIncident.VictimGender]
                  ]),
                  _createElementVNode("label", {
                    class: "btn btn-outline btn-outline-dashed btn-outline-default px-2 d-flex align-items-center justify-content-center",
                    for: VictimGender.id
                  }, [
                    _createElementVNode("span", _hoisted_23, [
                      _createElementVNode("span", _hoisted_24, _toDisplayString(_ctx.$t(VictimGender.name)), 1)
                    ])
                  ], 8, _hoisted_22)
                ]))
              }), 128)),
              _createVNode(_component_ErrorMessage, { name: "accountType" })
            ])
          ])
        ])
      ])
    ]),
    _hoisted_25,
    _createElementVNode("div", _hoisted_26, [
      _createElementVNode("h5", _hoisted_27, _toDisplayString(_ctx.$t("selectWhereTheIncidentOcurred")), 1)
    ]),
    (_openBlock(), _createBlock(_component_MapComponentOL, {
      mapid: "map1",
      ref: "theMap",
      key: 0,
      incidentsArray: _ctx.incidentsArray,
      siteViewParameters: _ctx.siteViewParameters,
      mapViewToSet: _ctx.mapView,
      maxLoadedImages: 15,
      imageIsLoading: _ctx.imageIsLoading,
      showButtons: false,
      imageDict: _ctx.imageData,
      showImage: _ctx.showImage,
      currentSelectMode: _ctx.mode,
      editedIncidentId: _ctx.listIncidents[0].Id,
      onViewChanged: _ctx.setMapView,
      onClickedCoordinates: _ctx.coordinateReceived
    }, null, 8, ["incidentsArray", "siteViewParameters", "mapViewToSet", "imageIsLoading", "imageDict", "showImage", "currentSelectMode", "editedIncidentId", "onViewChanged", "onClickedCoordinates"])),
    _createElementVNode("div", _hoisted_28, [
      _createElementVNode("div", _hoisted_29, [
        _createElementVNode("button", {
          type: "submit",
          ref: "submitButton",
          id: "kt_sign_in_submit",
          class: "btn btn-lg btn-primary w-25 mb-5",
          onClick: _cache[3] || (_cache[3] = 
//@ts-ignore
(...args) => (_ctx.goToNextStep && _ctx.goToNextStep(...args))),
          disabled: 
            _ctx.myprops.incidentData.value.landIncident.VictimAge == null ||
            _ctx.myprops.incidentData.value.landIncident.VictimGender == null ||
            _ctx.myprops.incidentData.value.landIncident.VictimName == '' ||
            _ctx.myprops.incidentData.value.landIncident.X == null ||
            _ctx.myprops.incidentData.value.landIncident.Y == null
          
        }, [
          _createElementVNode("span", _hoisted_31, _toDisplayString(_ctx.$t("continue")), 1)
        ], 8, _hoisted_30)
      ])
    ])
  ]))
}